import { createRouter, createWebHistory } from 'vue-router'

const viewContext = require.context('../views/', false, /\.vue$/)
const docContext = require.context('../components/documentation/', false, /\.vue$/)
const themeContext = require.context('../components/themes/', true, /[A-Z][\w-]+View\.vue$/)

const routes = []

viewContext.keys().forEach(path => {
  const name = path.match(/\.\/([\w-]+)\.vue$/)?.[1]
  if (!name) return
  let routePath = name.toLowerCase() === 'homeview' ? '/' : `/${name.replace(/view/i, '').toLowerCase()}`

  let title = `${name.replace(/view/i, '')} – Creative Commerce`

  if (name.toLowerCase() === 'homeview') title = 'Creative Commerce – Shopify Premium Themes'
  if (name.toLowerCase() === 'helpview') {
    routePath = '/help-center'
    title = 'Help Center – Creative Commerce'
  }
  if (name.toLowerCase() === 'privacyview') title = 'Privacy Policy – Creative Commerce'
  if (name.toLowerCase() === 'termsview') title = 'Terms & Conditions – Creative Commerce'

  routes.push({
    path: routePath,
    name: name.replace(/view/i, '').toLowerCase(),
    component: viewContext(path).default,
    meta: { title }
  })
})

docContext.keys().forEach(path => {
  const fileName = path.match(/Doc([\w-]+)View\.vue$/)?.[1]
  if (!fileName) return
  routes.push({
    path: `/help-center/documentation/${fileName.toLowerCase()}`,
    name: `doc${fileName.toLowerCase()}`,
    component: docContext(path).default,
    meta: { title: `${fileName} Documentation – Creative Commerce` }
  })
})

themeContext.keys().forEach(path => {
  const themeMatch = path.match(/\.\/([\w-]+)\/([\w-]+)View\.vue$/)
  if (!themeMatch) return
  const theme = themeMatch[1]
  const themeCapitalized = theme.charAt(0).toUpperCase() + theme.slice(1)
  routes.push({
    path: `/themes/${theme.toLowerCase()}`,
    name: theme.toLowerCase(),
    component: themeContext(path).default,
    meta: { title: `${themeCapitalized} Theme – Creative Commerce` }
  })
})

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to && to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta?.title || 'Creative Commerce – Shopify Premium Themes'
  next()
})

export default router
